export default {"src":"/_next/static/media/resolve_tick.7406b7d1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};